import { post } from "./fetch_api";

const baseUrl = `${process.env.REACT_APP_GATEWAY_URL}/services/userprofile/api`;

export const createSingleConsultation = async (token, displayError) => {
  try {
    const response = await post(
      `${baseUrl}/single-consultation`,
      { status: "GENERATED" },
      {
        Authorization: `Bearer ${token}`,
      }
    );
    return response;
  } catch (error) {
    displayError("Error al generar la consulta única");
    console.error("Error creating single consultation:", error);
    return null;
  }
};
